define((require) => {
    "use strict";

    const Effect            = require("shared/ui/experience/widgets/effects/Effect");
    const Preconditions     = require("shared/util/Preconditions");
    const RotateEffectModel = require("shared/ui/experience/action/effects/RotateEffectModel");

    return Effect.extend({

        config() {
            let rotation;
            let yoyo;

            switch (this.model.get("attentionMode")) {
                case RotateEffectModel.MODE.Angle: {
                    if (this.model.get("rotation") < 0) {
                        rotation = `-=${this.model.get("rotation")}`;
                    } else {
                        rotation = `+=${this.model.get("rotation")}`;
                    }

                    yoyo = true;
                    break;
                }

                case RotateEffectModel.MODE.Infinite: {
                    const isRotatingClockwise = this.model.get("rotationDirection") === RotateEffectModel.DIRECTION.Clockwise;
                    rotation = isRotatingClockwise ? "+=360" : "-=360";
                    yoyo = false;
                    break;
                }

                default: {
                    Preconditions.fail(`${this.model.get("attentionMode")} is not a supported attentionMode.`);
                }
            }

            return {
                rotation,
                yoyo,
                transformOrigin: "50% 50%",
                ease: Effect.Easing.Linear.easeNone
            };
        }

    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/effects/RotateEffect.js